import React from 'react';
import { useRouteError } from 'react-router-dom';

// import utils
import { setBodyBackgroudColor } from 'js/utils/general';

// import containers
import SectionPageWrapper from 'js/containers/section/Section.page-wrapper';
import TransitionPage from 'js/containers/transition/Transition.page';

export default function ErrorPage() {
  const error = useRouteError();

  React.useEffect(() => {
    setBodyBackgroudColor('#F7EBB1');
  }, []);
  return (
    <TransitionPage>
      <SectionPageWrapper className="page--error" bgColor="#F7EBB1">
        <h1>Sorry, an unexpected error has occurred.</h1>
        <p>
          <i>{error.statusText || error.message}</i>
        </p>
      </SectionPageWrapper>
    </TransitionPage>
  );
}
